var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFailure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 546,
    height: 553,
    viewBox: "0 0 546 553",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_199_249)",
    filter: "url(#filter0_d_199_249)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_199_249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.747 386.061C221.446 386.061 219.21 385.294 217.382 383.879C215.554 382.465 214.237 380.48 213.633 378.232L191.496 296.34L172.275 324.944C171.312 326.375 170.018 327.546 168.506 328.355C166.994 329.164 165.309 329.586 163.599 329.585H109.273C106.491 329.585 103.822 328.466 101.854 326.474C99.8869 324.482 98.7815 321.781 98.7815 318.964C98.7815 316.147 99.8869 313.445 101.854 311.453C103.822 309.461 106.491 308.342 109.273 308.342H158.049L186.943 265.346C188.072 263.672 189.652 262.361 191.494 261.567C193.336 260.773 195.364 260.529 197.338 260.864C199.313 261.199 201.151 262.099 202.637 263.458C204.123 264.816 205.193 266.577 205.723 268.532L220.379 322.702L233.725 225.174C234.04 222.855 235.103 220.706 236.749 219.062C238.395 217.417 240.532 216.369 242.827 216.081C245.121 215.793 247.446 216.28 249.439 217.467C251.432 218.655 252.982 220.475 253.848 222.646L281.021 290.413H340.645C343.427 290.413 346.096 291.532 348.064 293.524C350.031 295.516 351.136 298.217 351.136 301.034C351.136 303.851 350.031 306.553 348.064 308.545C346.096 310.537 343.427 311.656 340.645 311.656H273.95C269.68 311.656 265.84 309.043 264.224 305.039L249.137 267.385L234.134 376.894C233.452 381.886 229.402 385.71 224.419 386.029C224.198 386.05 223.968 386.061 223.747 386.061V386.061ZM472 511.099V536.378C472 542.22 467.279 547 461.508 547H419.227C415.45 547 411.883 544.876 410.099 541.583L393.313 511.099H472V511.099ZM168.687 511.099L151.901 541.583C150.99 543.224 149.664 544.59 148.061 545.542C146.457 546.493 144.632 546.997 142.773 547H100.492C94.7212 547 90 542.22 90 536.378V511.099H168.687V511.099ZM457.469 304.773C464.992 304.773 471.108 298.581 471.108 290.965C471.108 283.296 464.992 277.051 457.469 277.051C449.894 277.051 443.725 283.296 443.725 290.965C443.725 298.581 449.894 304.773 457.469 304.773Z",
    fill: "#B13035"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_199_249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M477.855 112H68.145C55.6414 112 43.6499 117.017 34.8085 125.946C25.967 134.876 21 146.987 21 159.615V441.384C21 454.013 25.967 466.124 34.8085 475.054C43.6499 483.983 55.6414 489 68.145 489H477.855C490.359 489 502.35 483.983 511.192 475.054C520.033 466.124 525 454.013 525 441.384V159.615C525 146.987 520.033 134.876 511.192 125.946C502.35 117.017 490.359 112 477.855 112V112ZM457.852 162.468C467.052 162.496 475.865 166.207 482.36 172.787C488.855 179.366 492.503 188.279 492.502 197.57C492.502 216.871 476.962 232.566 457.852 232.566C448.652 232.569 439.826 228.886 433.311 222.325C426.796 215.765 423.123 206.862 423.097 197.57C423.109 188.264 426.774 179.342 433.289 172.762C439.805 166.181 448.638 162.479 457.852 162.468V162.468ZM457.852 255.324C467.052 255.352 475.865 259.062 482.36 265.642C488.855 272.222 492.503 281.134 492.502 290.425C492.502 309.726 476.962 325.421 457.852 325.421C448.652 325.424 439.826 321.741 433.311 315.181C426.796 308.62 423.123 299.718 423.097 290.425C423.109 281.119 426.774 272.198 433.289 265.617C439.805 259.037 448.638 255.335 457.852 255.324V255.324ZM370.44 419.751C276.224 452.203 174.016 452.203 79.8 419.751C52.5 333.11 52.5 267.89 79.8 181.143C174.033 148.799 276.207 148.799 370.44 181.143C397.74 267.89 397.74 333.004 370.44 419.751ZM486.644 439.582H428.957C426.172 439.582 423.501 438.464 421.532 436.476C419.563 434.487 418.457 431.789 418.457 428.977C418.457 426.164 419.563 423.467 421.532 421.478C423.501 419.489 426.172 418.372 428.957 418.372H486.644C489.428 418.372 492.099 419.489 494.068 421.478C496.037 423.467 497.144 426.164 497.144 428.977C497.144 431.789 496.037 434.487 494.068 436.476C492.099 438.464 489.428 439.582 486.644 439.582ZM486.644 393.568H428.957C426.172 393.568 423.501 392.45 421.532 390.461C419.563 388.473 418.457 385.775 418.457 382.963C418.457 380.15 419.563 377.453 421.532 375.464C423.501 373.475 426.172 372.358 428.957 372.358H486.644C489.428 372.358 492.099 373.475 494.068 375.464C496.037 377.453 497.144 380.15 497.144 382.963C497.144 385.775 496.037 388.473 494.068 390.461C492.099 392.45 489.428 393.568 486.644 393.568Z",
    fill: "#B13035"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_199_249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M457.357 212C464.882 212 471 205.806 471 198.188C471 190.517 464.882 184.27 457.357 184.27C449.781 184.27 443.61 190.517 443.61 198.188C443.61 205.806 449.781 212 457.357 212ZM416.902 37.98C416.902 55.6168 402.735 69.96 385.314 69.96C375.974 69.96 367.474 65.7101 361.912 59.1229L324.552 72.9349C330.849 78.1409 336.411 84.3032 341.238 91.2091H187.497C191.59 85.4719 196.207 80.2658 201.245 75.6973L163.99 61.7791C161.055 65.1622 157.439 67.8702 153.384 69.7211C149.329 71.572 144.93 72.5228 140.483 72.5099C123.167 72.5099 109 58.1667 109 40.6361C109 22.9993 123.167 8.65615 140.483 8.65615C157.903 8.65615 171.966 22.9993 171.966 40.6361C171.966 41.1674 171.966 41.5923 171.861 42.1236L222.758 60.9291C235.561 54.5543 249.728 51.1545 264.42 51.1545C277.433 51.1545 290.026 53.8106 301.57 58.9104L354.041 39.4674C353.936 38.9362 353.936 38.5112 353.936 37.98C353.936 20.3432 367.999 6 385.314 6C402.735 6 416.902 20.3432 416.902 37.98V37.98Z",
    fill: "#B13035"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_199_249",
    x: -6,
    y: 0,
    width: 552,
    height: 558,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_199_249"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_199_249",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_199_249",
    x: 84,
    y: 216,
    width: 388,
    height: 337,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_199_249"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_199_249",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_199_249",
    x: 15,
    y: 112,
    width: 510,
    height: 383,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_199_249"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_199_249",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_199_249",
    x: 103,
    y: 6,
    width: 368,
    height: 212,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_199_249"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_199_249",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_199_249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 546,
    height: 552,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailure);
export default __webpack_public_path__ + "static/media/failure.0c537fc19384c2b7692899ddcbc004b0.svg";
export { ForwardRef as ReactComponent };